// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe, arrayOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

const trackedLink = objectOf({
  _id: string,
  l_id: string,
  name: string,
  is_cb_link: boolean,
  is_active: boolean,
  url: maybe(string),
  campaign_name: maybe(string),
  campaign_url: maybe(string),
});

export const isGetTrackedLinksResult = objectOf({
  tracked_links: arrayOf(trackedLink),
});
